import transformLatLong from "./utils/transformLatLongFn";

let azLatLong = [34.105, -111.831];
export default transformLatLong(azLatLong);
